export default {
	setupWizard_appearance_caption: 'Pick the theme mode and accent color.',
	setupWizard_appearance_title: 'Appearance',

	setupWizard_back: 'Back',
	setupWizard_defer: 'Later',
	setupWizard_features_caption: 'Enable optional features.',
	setupWizard_features_title: 'Features',
	setupWizard_finish: "Let's go",
	setupWizard_get_started: 'Get started',

	setupWizard_layout_caption: 'Fine-tune icons, buttons, navigation, and readability.',
	setupWizard_layout_title: 'Buttons, icons & layout',
	setupWizard_next: 'Next',
	setupWizard_settings_relaunch_button: 'Open assistant',

	setupWizard_settings_relaunch_caption: 'Walks you through the most important settings again.',
	setupWizard_settings_relaunch_label: 'Restart setup assistant',

	setupWizard_settings_relaunch_title: 'Setup assistant',
	setupWizard_skip: 'Skip setup',

	setupWizard_summary_buttons: 'Buttons',
	setupWizard_summary_caption: 'You can change everything later under Settings → Workspace.',
	setupWizard_summary_features: 'Features',
	setupWizard_summary_layout: 'Layout',
	setupWizard_summary_separator: ' · ',
	setupWizard_summary_theme: 'Theme',
	setupWizard_summary_title: 'You’re all set{name}!',

	setupWizard_summary_work_mode: 'Work mode',

	setupWizard_welcome_card_appearance_caption: 'Mode, primary color, surface',
	setupWizard_welcome_card_features_caption: 'Timer, spotlight search, online users',
	setupWizard_welcome_card_layout_caption: 'Font size, icon style, buttons, navigation',
	setupWizard_welcome_card_work_mode_caption: 'Tab workspace or focus view',
	setupWizard_welcome_footnote: 'You can change everything later in Settings.',
	setupWizard_welcome_subtitle: "Let's get your workspace set up in a few quick steps.",
	setupWizard_welcome_title: 'Welcome{name}!',
	setupWizard_work_mode_caption:
		'Choose how infra-struktur arranges modules and records. You can change this anytime in the settings.',
	setupWizard_work_mode_focus_description:
		'No tab bar: navigate via the menu with the list and the opened entry side by side — tidy and focused.',
	setupWizard_work_mode_focus_title: 'Focus view',
	setupWizard_work_mode_tabs_description:
		'Modules and records open as full-width tabs — just like the previous infra-struktur interface.',
	setupWizard_work_mode_tabs_title: 'Tab workspace',
	setupWizard_work_mode_title: 'Work mode',
};
